<template>
  <div class="global-header">
    <h1 :style="display_style[appType]">
      TPDDNS 实名认证
      <div class="right" :style="display_style2[appType]">
        <span v-if="appType==='CERTIFICATION_PC'" style="margin-right: 5px"> {{ accountName }} </span>
        <el-link type="primary" style="font-size: 18px" @click="logout"> 退出 </el-link>
      </div>
    </h1>
    <div class="divider" />
  </div>
</template>

<script>
import Cookies from "js-cookie";
import { removeToken } from "@/utils/auth";

export default {
  name: "GlobalHeader",
  props: {
    appType: {
      type: String,
      default: "CERTIFICATION_PC"
    }
  },
  data () {
    return {
      accountName: localStorage.getItem("accountName"),
      display_style: {CERTIFICATION_MOBILE: "margin: 2% 5%;", CERTIFICATION_PC: "margin: 2% 20%;"},
      display_style2: {CERTIFICATION_MOBILE: "display: block;", CERTIFICATION_PC: "float: right;"}
    }
  },
  watch: {
    appType: function () {
      console.log("appType", this.appType, this.display_style[this.appType])
    }
  },
  methods: {
    logout () {
      Cookies.remove("accountName")
      Cookies.remove("accountPassword")
      Cookies.remove("rememberMe")
      removeToken()
      console.log('Back to login page!')
      this.$router.replace("/login")
    }
  }
}
</script>

<style scoped>
.global-header {
  width: 100%;
  height: 100%;
}

.divider {
  height: 15%;
  background-color: #EBEEF5;
}
</style>
